import React, { useState } from 'react';
import { ImageEndPoint } from 'config/config';

function AutoSearch({
  suggestions,
  placeholder,
  selectvalue,
  input,
  setInput,
}) {
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [activeSuggestionIndex, setActiveSuggestionIndex] = useState(0);
  const [showSuggestions, setShowSuggestions] = useState(false);
  // const [input, setInput] = useState('');

  let arr = [];

  let arrId = [];

  const result = suggestions.forEach((item) => {
    return arr.push(item.name);
  });

  const resultId = suggestions.forEach((item) => {
    return arrId.push(item._id);
  });

  const onChange = (e) => {
    const userInput = e.target.value;

    // Filter our suggestions that don't contain the user's input
    const unLinked = suggestions.filter(
      (suggestion) =>
        suggestion.name.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );

    setInput(e.target.value);
    setFilteredSuggestions(unLinked);
    setActiveSuggestionIndex(0);
    setShowSuggestions(true);
  };

  const onClick = (e) => {
    setInput(e.target.innerText);
    selectvalue(e.target.innerText, e.target.id);
    // console.log(e.target.id);
    setFilteredSuggestions([]);

    setActiveSuggestionIndex(0);
    setShowSuggestions(false);
  };

  const onKeyDown = (e) => {
    // User pressed the enter key
    if (e.keyCode === 13) {
      setInput(filteredSuggestions[activeSuggestionIndex].name);
      selectvalue(
        filteredSuggestions[activeSuggestionIndex].name,
        filteredSuggestions[activeSuggestionIndex]._id
      );

      setActiveSuggestionIndex(0);
      setShowSuggestions(false);
    }
    // User pressed the up arrow
    else if (e.keyCode === 38) {
      if (activeSuggestionIndex === 0) {
        return;
      }

      setActiveSuggestionIndex(activeSuggestionIndex - 1);
    }
    // User pressed the down arrow
    else if (e.keyCode === 40) {
      if (activeSuggestionIndex - 1 === filteredSuggestions.length) {
        return;
      }

      setActiveSuggestionIndex(activeSuggestionIndex + 1);
    }
  };

  const SuggestionsListComponent = () => {
    return filteredSuggestions.length ? (
      <ul className='suggestions bg-white rounded border border-color-grey mt-2 h-52 absolute z-10'>
        {filteredSuggestions.map((suggestion, index) => {
          let className = '';

          // Flag the active suggestion with a class
          if (index === activeSuggestionIndex) {
            className = 'suggestion-active ';
          }

          return (
            <li
              className={className + 'p-3 flex'}
              key={suggestion._id}
              onClick={onClick}
              id={suggestion._id}
            >
              <img
                src={ImageEndPoint + suggestion.image}
                className='w-10 h-10 rounded-full object-cover'
                alt=''
                id={suggestion._id}
              />
              <span id={suggestion._id} className='m-2'>
                {suggestion.name}
              </span>
            </li>
          );
        })}
      </ul>
    ) : (
      <div className='no-suggestions'>
        <em>sorry no suggestions</em>
      </div>
    );
  };
  return (
    <div className=''>
      <input
        type='text'
        onChange={onChange}
        onKeyDown={onKeyDown}
        value={input}
        placeholder={placeholder}
        className='input-styl w-10'
      />
      {showSuggestions && input && <SuggestionsListComponent />}
    </div>
  );
}

export default AutoSearch;
